<template>
    <!-- 审批记录 -->
    <div class="details" v-if="list.length > 0">
        <header class="title">
            <span class="pole"></span>
            <span class="str_border_null" style="margin-bottom: 0">审批记录</span>
        </header>
        <van-steps direction="vertical" :active="active" class="step">
            <van-step v-for="(item,index) in list" :key="index">
                <div v-for="(itex,indet) in item" :key="indet">
                    <h3 :style="{color: itex.color}">
                        <span>{{ itex.userName }}</span>
                        <span class="fr">{{ itex.userTaskEndtime }}</span>
                    </h3>
                    <div :style="{color: itex.color}">
                        <span v-if="itex.suggestion">意见：{{ itex.suggestion }}</span><br>
                        <span v-if="itex.details" class="sug-details">详情：{{ itex.details }}</span>
                    </div>
                </div>
            </van-step>
        </van-steps>
    </div> 
</template>
<script>
import {getApprovalRecordsData} from '@/api/approve.js'
export default {
    props: {
        workFlowGuid: String,
        workFlowFormVar: Object,
        workFlowFormKey: String
    },
    data(){
        return {
            list:[],
            activeColor:'',
            active: -1,
        }
    },
    watch:{
        workFlowGuid: {
            deep: true,
            immediate: true,
            handler(val,old){
                if(JSON.stringify(val)!=JSON.stringify(old)){
                    this.getApprovalRecordDataEvent()
                }
            },
        },
        workFlowFormVar:{
            deep:true,
            immediate:true,
            handler(val,old){
                if(JSON.stringify(val)!=JSON.stringify(old)){
                    this.getApprovalRecordDataEvent()
                }
            }
        }
    },
    methods:{
        //获取审批记录数据
        async getApprovalRecordDataEvent(){
            if(!this.workFlowGuid){
                return
            }
            try {
                //请求数据
                let params = {
                    businessKey: this.workFlowGuid,
                    formVar: JSON.stringify(this.workFlowFormVar),
                    formKey: this.workFlowFormKey
                }
                let res = await getApprovalRecordsData(params);
                let data = res.data.data;
                this.list = data.historyInfo.sort((a,b)=>{
                    return new Date(a.userTaskEndtime) - new Date(b.userTaskEndtime)
                }).map((item,index)=>{
                    item.userTaskEndtimeDate = new Date(item.userTaskEndtime);
                    let ops = item.userOpinion.split("&");
                    item.suggestion = ops[0];
                    item.details = ops[1];
                    item.color = "#9a9b9d";
                    return [item]
                });
                console.log(this.list);
                this.active = this.list.length - 1;
                console.log(this.active);
                console.log("???");
                this.list[this.active].forEach(item => {
                    if(item.suggestion == "同意") {
                        item.color = "#07c160";
                    } else if(item.suggestion == "驳回"){
                        item.color = "red";
                    }
                })
                let curNode = data.userListYes.find(item=>{
                    return item.userTaskId == data.currUserTaskSid
                })
                if(curNode){
                    let obj = curNode.userList.filter(item=>{
                        return !item.userTaskEndtime
                    }).map(item=>{
                        item.suggestion = "待审批";
                        item.details = "";
                        item.color = "#0ea6e0";
                        return item
                    })
                    this.list.push(obj);
                }
            } catch(e) {
                console.log("进来")
                this.Toast({message: e,size: "small"});
            }
        },
    }
}
</script>
<style lang="less" scoped>
    //主标题字号
    @titleSize: 16px;
    //主标题颜色
    @titleColor: #0ea6e0;
    //中等字号
    @middleSize: 14px;
    //主体小字字号
    @contentSize: 12px;
    //内容小字颜色
    @contentColor: #7f7f7f;

    //板块radius
    @borderRadius: 4px;

    //边框阴影
    @boxShadow: 2px 2px 5px 0 rgba(0, 0, 0, 0.2);

    //预览标题颜色
    @previewColor: #000;

    .details{
        background-color: #fff;
        border-radius: @borderRadius;
        box-shadow: @boxShadow;
        overflow: hidden;
        margin-top: 15px;
        padding-bottom: 10px;
        text-align: left;
        font-size: @contentSize;
        .title{
            margin: 20px 15px 0 15px;
            text-align: left;
            overflow: hidden;
            position: relative;
            .pole{
                color: @titleColor;
                font-size: @titleSize;
                border-left: 3px solid #0ea6e0;
            }
            .str_border_null{
                width: 100%;
                font-size: @middleSize;
                display: inline-block;
                margin-left: 5px;
                font-weight: bold;
                padding-bottom: 5px;
                border-bottom: 1px solid #d7d7d7;
            }
            .str_border_null{
                border: unset;
                width: 80%;
                margin-bottom: 5px;
            }
        }
        .content:last-child{
            border: unset;
        }
        .step{
            h3{
                padding: 0;
                margin: 0 0 5px 0;
                overflow: hidden;
                .fr{
                    float: right;
                }
            }
            p{
                padding: 0;
                margin: 0 0 5px 0;
                font-size: 12px;
            }
            div{
                margin-left: 10px;
            }
            .sug-details{
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 3;
            }
        }
    }
    /deep/ .van-steps {
        .van-steps__items {
            display: flex;
            flex-direction: column-reverse;
            .van-hairline:first-child{
                .van-step__line{
                    width: 0;
                    background: unset;
                }
            }
            .van-hairline:last-child{
                .van-step__line{
                    width: 1px;
                    background: #07c160;
                }
            }
        }
    }
</style>